module.exports = __webpack_public_path__ + "static/assets/c39d0bfca9c8ad337311e15210f06edf.svg";